module.exports = "download-img {\n  width: 90px;\n  height: 90px; }\n\n.img {\n  max-width: 90px;\n  max-height: 90px; }\n\n.full {\n  width: \"100%\"; }\n"